// src/FAQScreen.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronDown, ChevronUp } from 'lucide-react';

// Dados do FAQ (equivalente à lista no código Kotlin)
const faqData = [
  {
    question: "Quais são exemplos de fotos aceitáveis?",
    answer: "Para garantir a validação correta, a foto deve estar nítida, centralizada e capturar todo o compartimento do caminhão. Evite cortes, reflexos e sombras.",
    // --- CORREÇÃO AQUI ---
    correctImages: [
      process.env.PUBLIC_URL + '/boa-1.png', 
      process.env.PUBLIC_URL + '/boa-2.png', 
      process.env.PUBLIC_URL + '/boa-3.png'
    ]
  },
  {
    question: "Quais exemplos de fotos são inaceitáveis?",
    answer: "Evite fotos borradas, com cortes, reflexos, excesso de sombra ou muito próximas/longe do caminhão.",
    // --- CORREÇÃO AQUI ---
    incorrectImages: [
      process.env.PUBLIC_URL + '/ruim-1.png', 
      process.env.PUBLIC_URL + '/ruim-2.png', 
      process.env.PUBLIC_URL + '/ruim-3.png'
    ]
  },
  {
    question: "Qual é a distância ideal para tirar as fotos dos caminhões?",
    answer: "A distância recomendada é de aproximadamente 3,5 metros de distância e 1,5 metros de altura."
  },
  {
    question: "Posso usar fotos tiradas anteriormente ou da galeria?",
    answer: "Não, as fotos devem ser capturadas diretamente pelo aplicativo para garantir autenticidade."
  },
  {
    question: "O que fazer se a câmera não estiver funcionando?",
    answer: "Verifique se o aplicativo tem permissão para acessar a câmera nas configurações do navegador. Caso o problema persista, tente recarregar a página ou contate o suporte técnico."
  },
  {
    question: "Como saber se a foto foi enviada com sucesso?",
    answer: "Após o envio dos dados, você será redirecionado para uma tela de sucesso ou de erro, informando o resultado da operação."
  },
  {
    question: "Tirei a foto mas ela não apareceu no histórico, o que fazer?",
    answer: "O processo para salvar a foto pode levar alguns segundos. Se a foto não aparecer após alguns minutos, verifique sua conexão com a internet e tente novamente. Se o problema persistir, entre em contato com o suporte técnico."
  }
];

// Componente para um único item do FAQ
const FAQItem = ({ faq, isOpen, onClick }) => (
  <div className="py-4 border-b">
    <div 
      className="flex justify-between items-center cursor-pointer" 
      onClick={onClick}
    >
      <h3 className="font-bold text-lg text-gray-800">{faq.question}</h3>
      {isOpen ? <ChevronUp className="text-[#EE4D2D]" /> : <ChevronDown className="text-[#EE4D2D]" />}
    </div>
    {isOpen && (
      <div className="mt-4 text-gray-600">
        <p>{faq.answer}</p>
        {faq.correctImages && (
          <ImageCarousel title="Exemplos de fotos corretas:" images={faq.correctImages} />
        )}
        {faq.incorrectImages && (
          <ImageCarousel title="Evite fotos como estas:" images={faq.incorrectImages} />
        )}
      </div>
    )}
  </div>
);

// Componente para o carrossel de imagens
const ImageCarousel = ({ title, images }) => (
  <div className="mt-4">
    <p className="font-semibold mb-2">{title}</p>
    <div className="flex space-x-4 overflow-x-auto p-2">
      {images.map((img, index) => (
        <img 
          key={index} 
          src={img} 
          alt={`Exemplo ${index + 1}`} 
          className="w-28 h-28 object-cover rounded-lg shadow-md flex-shrink-0" 
        />
      ))}
    </div>
  </div>
);

// Componente principal da tela
export default function FAQScreen() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null); // Controla qual item está aberto

  return (
    <div className="min-h-screen bg-white p-6">
      <div className="flex items-center mb-6 relative">
        <button onClick={() => navigate('/home')} className="p-2 absolute left-0">
          <ArrowLeft size={24} className="text-[#EE4D2D]" />
        </button>
        <h1 className="text-xl font-bold text-[#EE4D2D] text-center flex-grow">
          Dúvidas Frequentes
        </h1>
      </div>

      <h2 className="text-3xl font-bold text-gray-900 mb-6">
        Dúvidas Frequentes
      </h2>

      <div>
        {faqData.map((faq, index) => (
          <FAQItem 
            key={index}
            faq={faq}
            isOpen={openIndex === index}
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          />
        ))}
      </div>
    </div>
  );
}